import React, { useEffect, useState } from "react";

import {
  IonCard,
  IonCardContent,
  IonIcon,
  IonPopover,
  IonAlert,
  IonButton,
} from "@ionic/react";

import "./MediaListCard.scss";
import {
  arrowRedoOutline,
  arrowUndoOutline,
  closeCircleOutline,
  ellipsisVertical,
  menuOutline,
  trashOutline,
} from "ionicons/icons";
import _ from "lodash";
import ReactPlayer from "react-player";
import { findDOMNode } from "react-dom";
// import screenfull from 'screenfull'
import * as screenfull from "screenfull";
import { Screenfull } from "screenfull";
import { StreamingMedia } from "@ionic-native/streaming-media";

import {
  MediaItemDeleteModel,
  MediaShareInterface,
} from "../FileShareMediaList/FileShareMediaList.model";
import { FileShareMediaListService } from "../FileShareMediaList/FileShareMediaList.service";
import { utilService } from "../../../../services/utilService";
import { useToast } from "@agney/ir-toast";
import { Link } from "react-router-dom";
import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";
import { CONSTANTS } from "../../../../constants";
import moment from "moment";
import { dataTransferService } from "../../../../services/dataTransferService";
import HistoryListCard from "../HistoryListCard/HistoryListCard";
import { useTranslation } from "react-i18next";


interface MediaCardParams {
  mediaItem: any;
  selectedDoctorData: any;
  selectedUserId: any;
  selectedPatientId: any;
  fromMessageListCard?: any;
  fromHistoryList?: any;
  fromHomeUserChat?: any;
  smsThreadId?: any;
  fromFileShare?: any;
  fromFileShareWeb?: any;
}
const MediaListCard: React.FC<MediaCardParams> = (props) => {
  const { t } = useTranslation("messages");
  const [MediaListHistoryData, setMediaListHistoryData]: any = useState([]);
  const [showDeleteAlert, setShowDeleteAlert]: any = useState(false);
  const [player, setPlayer]: any = useState({});
  const [isWeb, setIsWeb]: any = useState(false);
  const [playerPopUpModal, setPlayerPopUpModal]: any = useState(false);
  const [showMoreButton, setShowMoreButton] = useState(false);
  const [isMoreButtonClicked, setIsMoreButtonClicked] = useState(false);

  const [popoverState, setShowPopover] = useState({
    showPopover: false,
    event: undefined,
  });

  const [baseUrl, setBaseAppUrl]: any = useState();

  useEffect(() => {
    let baseAppURL = (window as any)._env_?.REACT_APP_API_URL;
    setBaseAppUrl(baseAppURL);
  }, []);

  useEffect(() => {
    if (utilService.isWeb()) {
      setIsWeb(true);
    }
  }, []);

  useEffect(() => {
    if (!_.isEmpty(props.mediaItem.message)) {
      let length;
      utilService.getScreenSize() === "small" ? (length = 18) : (length = 30);
      props.mediaItem.message.length > length
        ? setShowMoreButton(true)
        : setShowMoreButton(false);
    }
  }, [props.mediaItem]);

  const Toast = useToast();

  if (document.addEventListener) {
    document.addEventListener("fullscreenchange", exitHandler, false);
    document.addEventListener("mozfullscreenchange", exitHandler, false);
    document.addEventListener("MSFullscreenChange", exitHandler, false);
    document.addEventListener("webkitfullscreenchange", exitHandler, false);
  }

  function exitHandler() {
    var document: any = window.document;
    if (
      !document.webkitIsFullScreen &&
      !document.mozFullScreen &&
      !document.msFullscreenElement
    ) {
      setTimeout(() => {
        showPreview();
      }, 1000);
    }
  }

  const mapMessages = (item: any) => {
    if (!_.isEmpty(item)) {
      return item;
    } else {
      return "";
    }
  };

  const mapCreatedOn = (date: any) => {
    const utc = date;
    const createdOn = moment.utc(utc).local().format("MM-DD-YYYY, hh:mm A");
    return createdOn;
  };

  const removeCurrentCardItem = (item: any) => {
    const mediaListCard = document.getElementById(
      `media-list-card-item-${item.id}`
    );
    //To Delete the parent column
    mediaListCard?.parentElement?.parentElement?.parentElement?.parentElement?.style.setProperty(
      "display",
      "none"
    );
  };

  const deleteMediaListItem = async (item: any) => {
    const params: any = getDeleteMediaItemParams(item);
    const respFileShareMediaListResult: MediaItemDeleteModel =
      await FileShareMediaListService.deleteMediaListItem(params);
    if (respFileShareMediaListResult.isSuccess) {
      Toast.success("Deleted");
    } else {
      console.log("error");
      FileShareMediaListService.handleErrorResponse();
    }
  };

  const getDeleteMediaItemParams = (item: any) => {
    return {
      action: 5,
      id: item.id,
      type: item.type,
      reg_code: utilService.getNetwork(),
    };
  };

  const showHistoryListItemCard = (item: any) => {
    const doctorCard = document.getElementById(
      `history-list-card-item-${item.id}`
    );
    doctorCard?.style.setProperty("display", "block");
  };

  const hideHistoryListItemCard = (item: any) => {
    const doctorCard = document.getElementById(
      `history-list-card-item-${item.id}`
    );
    doctorCard?.style.setProperty("display", "none");
  };

  const getMediaListHistoryDetails = async (item: any) => {
    const params: any = getMediaListHistoryParams(item);
    const respMediaListHistoryResult: MediaShareInterface =
      await FileShareMediaListService.getMediaListHistoryDetails(params);
    if (
      respMediaListHistoryResult.isSuccess &&
      respMediaListHistoryResult.result
    ) {
      setMediaListHistoryData(respMediaListHistoryResult.result);
    } else {
      console.log("error");
      FileShareMediaListService.handleErrorResponse();
    }
  };

  const getMediaListHistoryParams = (item: any) => {
    return {
      id: item.id,
      reg_code: utilService.getNetwork(),
    };
  };

  const viewItem = (type: Number, id: Number) => {
    switch (type) {
      case CONSTANTS.MEDIA_TYPE.AUDIO:
        playAudio();
        break;
      case CONSTANTS.MEDIA_TYPE.VIDEO:
        viewVideo();
        break;
      case CONSTANTS.MEDIA_TYPE.IMAGE:
        viewImage(id);
        break;
      case CONSTANTS.MEDIA_TYPE.EKG:
        viewImage(id);
        break;
    }
  };

  const viewImage = (id: Number) => {
    viewWebImage(id);
  };

  const viewWebImage = (id: Number) => {
    const img: any = document.getElementById(`media-${id}`);
    const viewer = new Viewer(img, {
      backdrop: true,
      button: false,
      toolbar: 0,
      hide() {
        viewer.destroy();
      },
    });
    viewer.show();
  };

  const preview = () => {
    if (isWeb) {
      (screenfull as Screenfull).request(findDOMNode(player) as any);
    }
  };

  const showPreview = () => {
    if (player.context) {
      // player.showPreview();
    }
  };

  const reference = (player: any) => {
    setPlayer(player);
  };

  const viewVideo = () => {
    if (!isWeb) {
      viewNativeVideo();
    } else {
      preview();
    }
  };

  const viewNativeVideo = () => {
    StreamingMedia.playVideo(props.mediaItem.url);
  };

  const playAudio = () => {
    if (!isWeb) {
      playNativeAudio();
    } else {
      setPlayerPopUpModal(true);
    }
  };

  const playNativeAudio = () => {
    StreamingMedia.playAudio(props.mediaItem.url);
  };

  const onReplyClicked = () => {
    const replyData = {
      mediaItem: props.mediaItem,
      isCalledFromMediaListComponent: true,
      selectedPatientId: props.selectedPatientId,
      selectedUserId: props.selectedUserId,
      mediaAction: CONSTANTS.MEDIA_ACTIONS.REPLY,
      smsThreadId: props.smsThreadId,
    };
    dataTransferService.transferReplyMediaAction(replyData);
  };

  const onForwardClicked = () => {
    const replyData = {
      mediaItem: props.mediaItem,
      isCalledFromMediaListComponent: true,
      selectedPatientId: props.selectedPatientId,
      selectedUserId: props.selectedUserId,
      mediaAction: CONSTANTS.MEDIA_ACTIONS.REPLY,
    };
    dataTransferService.transferForwardMediaAction(replyData);
  };

  const handleMoreButtonClick = () => {
    const mediaListCard: any = document.getElementById(
      `case-media-list-card-item-wrapper${props.mediaItem.id}`
    );
    if (mediaListCard) {
      mediaListCard?.style.setProperty("height", "145px");
    }
  };

  const handleLessButtonClick = () => {
    const mediaListCard: any = document.getElementById(
      `case-media-list-card-item-wrapper${props.mediaItem.id}`
    );
    if (mediaListCard) {
      mediaListCard?.style.setProperty("height", "90px");
    }
  };

  return (
    <div>
      <IonCard>
        <IonCardContent>
          <div
            className={`media-list-card-item card-type-${props.mediaItem.type}`}
            id={`media-list-card-item-${props.mediaItem.id}`}
          >
            <div
              className="case-media-list-card-item-wrapper"
              id={`case-media-list-card-item-wrapper${props.mediaItem.id}`}
              onClick={() => {
                viewItem(props.mediaItem.type, props.mediaItem.id);
              }}
            >
              <div className="file-share-icon-div">
                {props.mediaItem.type === 2 && (
                  <div className="">
                    <div className="icon-audio" title=""></div>
                  </div>
                )}
                {props.mediaItem.type === 1 && (
                  <div className="">
                    <div className="icon-image" title=""></div>
                  </div>
                )}
                {props.mediaItem.type === 3 && (
                  <div className="">
                    <div className="icon-video" title=""></div>
                  </div>
                )}
                {props.mediaItem.type === 5 && (
                  <div className="">
                    <div className="icon-ekg" title=""></div>
                  </div>
                )}
              </div>
              <div
                className={`media-details-div ${
                  props.fromMessageListCard ? "user-details-message-list" : ""
                }`}
              >
                {props.mediaItem.type === CONSTANTS.MEDIA_TYPE.IMAGE && (
                  <img
                    className="hide-media-image"
                    id={`media-${props.mediaItem.id}`}
                    src={props.mediaItem.url}
                    alt="media"
                  />
                )}

                {props.mediaItem.type === CONSTANTS.MEDIA_TYPE.EKG && (
                  <img
                    className="hide-media-image"
                    id={`media-${props.mediaItem.id}`}
                    src={props.mediaItem.url}
                    alt="media"
                  />
                )}

                {props.mediaItem.type === 3 && isWeb && (
                  <ReactPlayer
                    ref={reference}
                    url={props.mediaItem.url}
                    light={false}
                    // onClickPreview={preview}
                    controls={true}
                    width={0}
                    height={0}
                  />
                )}

                <div
                  className={`media-details-name case-history-media-name ${
                    props.fromMessageListCard
                      ? "user-details-message-section"
                      : ""
                  }`}
                >
                  {props.mediaItem.name}
                </div>

                {!props.fromMessageListCard && (
                  <div
                    className={`media-details-message-wrapper ${
                      isMoreButtonClicked
                        ? "media-details-message-wrapper-more"
                        : ""
                    }`}
                  >
                    <div
                      className={`media-details-message ${
                        isMoreButtonClicked ? "media-details-message-more" : ""
                      }`}
                    >
                      Message: {mapMessages(props.mediaItem.message)}{" "}
                    </div>
                    <div className="more-button-div">
                      <IonButton
                        className={
                          showMoreButton && !isMoreButtonClicked
                            ? "more-button"
                            : "hide-button"
                        }
                        onClick={(e: any) => {
                          e.stopPropagation();
                          handleMoreButtonClick();
                          setIsMoreButtonClicked(true);
                        }}
                      >
                        + more
                      </IonButton>
                    </div>
                    <div className="more-button-div">
                      <IonButton
                        className={
                          isMoreButtonClicked ? "more-button" : "hide-button"
                        }
                        onClick={(e: any) => {
                          e.stopPropagation();
                          handleLessButtonClick();
                          setIsMoreButtonClicked(false);
                        }}
                      >
                        - Less
                      </IonButton>
                    </div>
                  </div>
                )}

                {!props.fromMessageListCard && (
                  <div className="media-details-created-on">
                    {mapCreatedOn(props.mediaItem.createdOn)}
                  </div>
                )}
              </div>
            </div>
            {!props.fromMessageListCard && (
              <div
                className="media-options-div"
                title="Media Options"
                onClick={(e: any) => {
                  e.persist();
                  e.stopPropagation();
                  setShowPopover({
                    showPopover: true,
                    event: e,
                  });
                }}
              >
                <IonIcon icon={ellipsisVertical}></IonIcon>
              </div>
            )}
          </div>
        </IonCardContent>
      </IonCard>

      <div
        id={`history-list-card-item-${props.mediaItem.id}`}
        className="history-list-card-item"
      >
        <div
          className="icon-close"
          onClick={() => {
            hideHistoryListItemCard(props.mediaItem);
          }}
        ></div>
        {!_.isEmpty(MediaListHistoryData) ? (
          MediaListHistoryData.map((historyItem: any) => {
            return (
              <HistoryListCard
                mediaItem={props.mediaItem}
                MediaListHistoryData={historyItem}
              ></HistoryListCard>
            );
          })
        ) : (
          <div className="no-history-div">
            <div className="empty-history-card">
              <div className="empty-history-label">No History Available</div>
            </div>
          </div>
        )}
      </div>

      <IonPopover
        className="media-list-options"
        event={popoverState.event}
        isOpen={popoverState.showPopover}
        onDidDismiss={() => {
          setShowPopover({ showPopover: false, event: undefined });
        }}
      >
        <div className="media-list-options-wrapper">
          <div
            className="media-list-icon"
            onClick={() => {
              setShowDeleteAlert(true);
            }}
          >
            <IonIcon icon={trashOutline} className="icon-div"></IonIcon>
            <div className="media-list-label">Delete</div>
          </div>
          <div
            className="media-list-icon"
            onClick={() => {
              getMediaListHistoryDetails(props.mediaItem);
              showHistoryListItemCard(props.mediaItem);
              setShowPopover({ showPopover: false, event: undefined });
            }}
          >
            <IonIcon icon={menuOutline} className="icon-div"></IonIcon>
            <div className="media-list-label">History</div>
          </div>
          {!props.selectedUserId && (
            <Link
              to={{
                pathname: "/client/file-share/upload-media",
                state: {
                  mediaItem: props.mediaItem,
                  isCalledFromMediaListComponent: true,
                  selectedDoctorData: props.selectedDoctorData,
                  mediaAction: CONSTANTS.MEDIA_ACTIONS.REPLY,
                  smsThreadId: props.smsThreadId,
                },
              }}
              style={{ textDecoration: "none" }}
            >
              <div className="media-list-icon">
                <IonIcon icon={arrowUndoOutline} className="icon-div"></IonIcon>
                <div className="media-list-label">Reply</div>
              </div>
            </Link>
          )}
          {props.selectedUserId && (
            <div
              className="media-list-icon"
              onClick={() => {
                onReplyClicked();
              }}
            >
              <IonIcon icon={arrowUndoOutline} className="icon-div"></IonIcon>
              <div className="media-list-label">Reply</div>
            </div>
          )}
          {!props.selectedUserId && (
            <Link
              to={{
                pathname: "/client/file-share/selectuser",
                state: {
                  mediaItem: props.mediaItem,
                  isCalledFromMediaListComponent: true,
                },
              }}
              style={{ textDecoration: "none" }}
            >
              <div className="media-list-icon">
                <IonIcon icon={arrowRedoOutline} className="icon-div"></IonIcon>
                <div className="media-list-label">Forward</div>
              </div>
            </Link>
          )}
          {props.selectedUserId && (
            <div
              className="media-list-icon"
              onClick={() => {
                onForwardClicked();
              }}
            >
              <IonIcon icon={arrowRedoOutline} className="icon-div"></IonIcon>
              <div className="media-list-label">Forward</div>
            </div>
          )}
        </div>
      </IonPopover>
      <IonAlert
        isOpen={showDeleteAlert}
        onDidDismiss={() => setShowDeleteAlert(false)}
        cssClass="media-list-delete-alert"
        header={t("confirmationMessage", "Confirmation Message")}
        message={t("deleteMediaConfirm", "Are you sure you want to delete this media?")}
        buttons={[
          {
            text: t("no", "NO"),
            role: "cancel",
            cssClass: "secondary",
          },
          {
            text: t("yes", "YES"),
            handler: () => {
              deleteMediaListItem(props.mediaItem);
              setShowPopover({ showPopover: false, event: undefined });
              removeCurrentCardItem(props.mediaItem);
            },
          },
        ]}
      />

      {!props.fromHistoryList &&
        props.mediaItem.type === 2 &&
        isWeb &&
        playerPopUpModal && (
          <div className="audio-player-div">
            <div
              className="close-icon"
              onClick={() => {
                setPlayerPopUpModal(false);
              }}
            >
              <IonIcon icon={closeCircleOutline}></IonIcon>
            </div>
            <audio autoPlay controls controlsList="nodownload">
              <source src={props.mediaItem.url} />
              Your browser does not support the audio element.
            </audio>
          </div>
        )}
      {props.fromHistoryList &&
        props.mediaItem.type === 2 &&
        isWeb &&
        playerPopUpModal && (
          <div className="audio-player-div message-history-audio-player">
            <audio autoPlay controls controlsList="nodownload">
              <source src={props.mediaItem.url} />
              Your browser does not support the audio element.
            </audio>
            <div
              className="close-icon"
              onClick={() => {
                setPlayerPopUpModal(false);
              }}
            >
              <IonIcon icon={closeCircleOutline}></IonIcon>
            </div>
          </div>
        )}
    </div>
  );
};

export default MediaListCard;
